module.exports = __webpack_public_path__ + "static/img/icon2.b5af27e0.png";